import { render, staticRenderFns } from "./LinkHotspotsMap.vue?vue&type=template&id=4735a9bc&scoped=true"
import script from "./LinkHotspotsMap.vue?vue&type=script&lang=ts"
export * from "./LinkHotspotsMap.vue?vue&type=script&lang=ts"
import style0 from "./LinkHotspotsMap.vue?vue&type=style&index=0&id=4735a9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4735a9bc",
  null
  
)

export default component.exports